import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const BudgetCreateModalUI = ({ context, messageList, successMsg, errorList, setErrorList,
  // modes
  createMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // budget name
  budgetName, onBudgetNameChange, budgetNameError, setBudgetNameError,
  // user id
  userId, userIdList, onUserIdChange, userIdError,
  // assigned amount
  assignedAmt, onAssignedAmtChange, assignedAmtError, setAssignedAmtError
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_create_budget'
    buttonMessageKey='c_create'
    cancelMessageKey='c_cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='budgetName' required={true} maxLength={100}
      messageList={messageList} labelKey='c_budget_name'
      value={budgetName} onChange={onBudgetNameChange}
      error={budgetNameError} setError={setBudgetNameError}
      autoFocus={true}
    />
    <InputSelectUI name='userId' value={userId} required={true}
      messageList={messageList} labelKey='c_assignee'
      optionList={userIdList}
      onChange={onUserIdChange} error={userIdError}
    />
    <InputTextSF type='price' name='assignedAmt' required={true} maxLength={13}
      messageList={messageList} labelKey='c_assigned_amount'
      value={assignedAmt} onChange={onAssignedAmtChange}
      error={assignedAmtError} setError={setAssignedAmtError}
      autoFocus={true}
    />
  </ModalFormUI>

export default BudgetCreateModalUI
